import { ShopperHomePage } from "./../pages/shopper-home/shopper-home";
import { MerchantHomePage } from "./../pages/merchant-home/merchant-home";
import { SplashScreen } from "@ionic-native/splash-screen";
import { HomePage } from "./../pages/home/home";
import { WaitStep3Page } from "./../pages/wait-step3/wait-step3";
import { QuizTestPage } from "./../pages/quiz-test/quiz-test";
import { QuizPage } from "./../pages/quiz/quiz";
import { WaitStep2Page } from "./../pages/wait-step2/wait-step2";
import { ShopperSelectTeamPage } from "./../pages/shopper-select-team/shopper-select-team";
import { MerchantSelectTeamPage } from "./../pages/merchant-select-team/merchant-select-team";
import { PlazaSelectTeamPage } from "./../pages/plaza-select-team/plaza-select-team";
import { Storage } from "@ionic/storage";
import { SelectLanguagePage } from "./../pages/select-language/select-language";
import { LoginPage } from "./../pages/login/login";
import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { TranslateService } from "@ngx-translate/core";
import { LoginSyncPlatformPage } from "../pages/login-sync-platform/login-sync-platform";

// declare var cordova;
@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    translate: TranslateService,
    private storage: Storage,
    SplashScreen: SplashScreen
  ) {
    platform.ready().then(() => {
      this.storage.get("stepGame").then((page) => {
        if (page == "syncPlatform") {
          this.rootPage = LoginSyncPlatformPage;
        } else if (page == "selectLang") {
          this.rootPage = SelectLanguagePage;
        } else if (page == "selectTeam") {
          this.storage.get("info").then((info) => {
            if (info.role == 1) {
              this.rootPage = PlazaSelectTeamPage;
            } else if (info.role == 2) {
              this.rootPage = MerchantSelectTeamPage;
            } else if (info.role == 3) {
              this.rootPage = ShopperSelectTeamPage;
            }
          });
        } else if (page == "waitStep2") {
          this.rootPage = WaitStep2Page;
        } else if (page == "quiz") {
          this.storage.get("info").then((info) => {
            this.rootPage = QuizPage;
          });
        } else if (page == "quizTest") {
          this.rootPage = QuizTestPage;
        } else if (page == "waitStep3") {
          this.rootPage = WaitStep3Page;
        } else if (page == "home") {
          this.storage.get("info").then((info) => {
            if (info.role == 1) {
              this.rootPage = HomePage;
            } else if (info.role == 2) {
              this.rootPage = MerchantHomePage;
            } else if (info.role == 3) {
              this.rootPage = ShopperHomePage;
            }
          });
        } else {
          this.rootPage = LoginPage;
        }
      });

      this.storage.get("language").then((language) => {
        if (language) {
          translate.setDefaultLang(language.trim());
        } else {
          translate.setDefaultLang("en-Us");
        }
      });

      // var successCallback = function(){
      //     console.log("The screenshots are not allowed now.");
      // };

      // var errorCallback = function(err){
      //     console.error("An error ocurred : " + err);
      // };

      // cordova.plugins.privacyscreen.disable(successCallback, errorCallback);

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.

      statusBar.styleDefault();
      SplashScreen.hide();

      // let splash = modalCtrl.create(Splash);
      // splash.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts